import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { syncVaspWallet } from '../vaspWalletEndpoints'

export function useSyncVaspWalletMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => syncVaspWallet(id),
    // `onSettled`, not `onSuccess`: a failure is itself evidence that the cached
    // view is wrong. A sync refused because the wallet moved underneath the
    // operator is the exact case where the drawer must re-read the row — that is
    // what turns "try again" (which would fail identically) into "refresh", and
    // what brings the failure sentence admin-service just recorded.
    //
    // Three trees: the row's status may have moved (list), which moves the bucket
    // totals (counts), and the drawer may be open on this very row (detail).
    onSettled: (_result, _error, id) => {
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.vaspWalletLists() })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.vaspWalletStatusCounts() })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.vaspWalletDetail(id) })
    },
  })
}
